import { render, staticRenderFns } from "./UlContentHeader.vue?vue&type=template&id=7263c95f&scoped=true&"
import script from "./UlContentHeader.vue?vue&type=script&lang=ts&"
export * from "./UlContentHeader.vue?vue&type=script&lang=ts&"
import style0 from "./UlContentHeader.vue?vue&type=style&index=0&id=7263c95f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7263c95f",
  null
  
)

export default component.exports